// extracted by mini-css-extract-plugin
export default {"date":"indexDate-module--date--3kdfU","day":"indexDate-module--day--tGTOp","month":"indexDate-module--month--1iPoN","year":"indexDate-module--year--1-Veg"};